import React, { useMemo, useState } from "react";
import ReviewCard from "./ReviewCard";
import ReviewFilters from "./ReviewFilters";
import { useCompany } from "../context/CompanyContext";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function ReviewsList() {
  const { reviews } = useCompany();
  const [sortBy, setSortBy] = useState("Helpful");
  const [activeTag, setActiveTag] = useState(null);
  const [query, setQuery] = useState("");
  const [activeRating, setActiveRating] = useState(null);
  const [page, setPage] = useState(1);

  const filtered = useMemo(() => {
    let arr = [...reviews];
    if (activeTag) arr = arr.filter((r) => (r.title + " " + r.content).toLowerCase().includes(activeTag.toLowerCase()));
    if (query) arr = arr.filter((r) => (r.title + " " + r.content).toLowerCase().includes(query.toLowerCase()));
    if (activeRating) arr = arr.filter((r) => r.rating && Math.round(r.rating) === activeRating);
    if (sortBy === "Helpful") arr.sort((a, b) => b.thanks - a.thanks);
    else arr.sort((a, b) => new Date(b.date) - new Date(a.date));
    return arr;
  }, [reviews, sortBy, activeTag, query, activeRating]);

  const totalPages = Math.max(5, Math.ceil(reviews.length / 5));
  const visiblePages = [1, 2, 3, 4, 5];

  return (
    <div className="grid grid-cols-1 lg:grid-cols-[1fr_320px] gap-6 mt-6">
      <div className="lg:hidden order-1">
        <ReviewFilters
          sortBy={sortBy} setSortBy={setSortBy}
          activeTag={activeTag} setActiveTag={setActiveTag}
          query={query} setQuery={setQuery}
          activeRating={activeRating} setActiveRating={setActiveRating}
        />
      </div>

      <div className="lg:order-1 order-2">
        {filtered.length === 0 ? (
          <div className="bg-white border border-gray-200 rounded-md p-10 text-center text-gray-500">
            No reviews match your filters.
          </div>
        ) : (
          filtered.map((r) => <ReviewCard key={r.id} review={r}/>)
        )}

        <div className="flex items-center justify-center gap-1 mt-6 flex-wrap">
          <button
            onClick={() => setPage(Math.max(1, page - 1))}
            className="p-2 rounded border border-gray-200 hover:bg-gray-50 disabled:opacity-50 text-gray-600"
            disabled={page === 1}
            aria-label="prev"
          >
            <ChevronLeft size={16}/>
          </button>
          {visiblePages.map((p) => (
            <button
              key={p}
              onClick={() => setPage(p)}
              className={`w-9 h-9 rounded text-sm font-medium ${
                p === page
                  ? "bg-[#007a8a] text-white"
                  : "border border-gray-200 text-gray-700 hover:bg-gray-50"
              }`}
            >
              {p}
            </button>
          ))}
          <span className="px-2 text-gray-400">…</span>
          <button className="w-12 h-9 rounded border border-gray-200 text-sm text-gray-700 hover:bg-gray-50">
            {totalPages}
          </button>
          <button
            onClick={() => setPage(page + 1)}
            className="p-2 rounded border border-gray-200 hover:bg-gray-50 text-gray-600"
            aria-label="next"
          >
            <ChevronRight size={16}/>
          </button>
        </div>
      </div>

      <aside className="hidden lg:block lg:order-2 order-1">
        <div className="sticky top-[120px]">
          <ReviewFilters
            sortBy={sortBy} setSortBy={setSortBy}
            activeTag={activeTag} setActiveTag={setActiveTag}
            query={query} setQuery={setQuery}
            activeRating={activeRating} setActiveRating={setActiveRating}
          />
          <div className="bg-white border border-gray-200 rounded-md p-4 text-center text-xs text-gray-400">
            <div className="mb-2 uppercase tracking-wider">Advertisements</div>
            <div className="h-[250px] bg-[#f5f7f8] rounded flex items-center justify-center text-gray-300 text-sm">
              Sponsored
            </div>
          </div>
        </div>
      </aside>
    </div>
  );
}
